export const TryAndBuy = {
    label: "tryAndBuy.label",
    notAvailable: "tryAndBuy.notAvailable",
    joinDescription: "tryAndBuy.joinDescription",
    selectSizeHint: "tryAndBuy.selectSizeHint",
    sizeNotAvailable: "tryAndBuy.sizeNotAvailable",
    contactDetails: "tryAndBuy.contactDetails",
    bar: {
        wantToReserve: "tryAndBuy.bar.wantToReserve",
        tooltip: "tryAndBuy.bar.tooltip",
    },
    success: {
        title: "tryAndBuy.success.title",
        description: "tryAndBuy.success.description",
        close: "tryAndBuy.success.close",
    },
    warning: {
        title: "tryAndBuy.warning.title",
        description: "tryAndBuy.warning.description",
        confirm: "tryAndBuy.warning.confirm",
        close: "tryAndBuy.warning.close",
    },
    store: {
        search: {
            placeholder: "tryAndBuy.store.search.placeholder",
        },
        storeInfo: "tryAndBuy.store.storeInfo",
    },
};
